import { DatePicker, IComboBoxOption, Panel, PanelType, TextField } from '@fluentui/react';
import { IFilter2, IT, keyType, textType } from '../UseReporteHistoricoEstado';
import { UseComboOperador } from './UseComboOperador';
import { UseComboEstadoEquipo } from './UseComboEstadoEquipo';
import { PanelHeader } from '../../../../../components/Panel/PanelHeader';
import { PanelFooter } from '../../../../../components/Panel/PanelFooter';
import { ComboBoxComponent } from '../../../../../components/comboBox/ComboBoxComponent';
import { useCallback, useState } from 'react';

export interface IPanelHistorico {
    filter2: IFilter2;
    isOpen: boolean;
    equipoAuxiliar?: boolean,
    onChangeComboFilter: (data: IT) => void
    resetFilter2: () => void;
    buscar: () => void;
    onDismiss: () => void;
    onChangeFecha:(key: string, value: string) => void
}

interface IR {
    data?: IComboBoxOption,
    key: keyType,
    text: textType
}
export const PanelHistoricoEquipoFil = ({
    isOpen,
    resetFilter2,
    onChangeComboFilter,
    filter2,
    buscar,
    onDismiss,
    onChangeFecha
}: IPanelHistorico) => {

    const { dataComboOperador, setFilterOperador, filterOperador } = UseComboOperador(isOpen, true);
    const { dataComboEstadoEquipo, setFilter, filter } = UseComboEstadoEquipo(isOpen);
    // const [fechaDesde, setFechaDesde] = useState<string>('');
    // const [fechaHasta, setFechaHasta] = useState<string>('');

    const handleOnChange = ({ data, key, text }: IR) => {
        if (data) {
            onChangeComboFilter({
                key,
                keyValue: `${data.key}`,
                text,
                textValue: data.text
            })
        }
    };

    return (
        <Panel
            type={PanelType.smallFixedFar}
            onRenderHeader={() =>
                <PanelHeader
                    textHeader={`Estados de Equipos`}
                    subTextHeader={`Búsqueda Avanzada`}
                />
            }
            onRenderFooter={() =>
                <PanelFooter
                    texto="Buscar"
                    texto2={"Limpiar"}
                    onClick={buscar}
                    disableButton={false}
                    onDismiss={resetFilter2}
                />
            }
            isFooterAtBottom
            isOpen={isOpen}
            onDismiss={onDismiss}
        >
            <div className="ms-Grid" dir="ltr">
                <TextField
                    type="date"
                    label="Desde"
                    placeholder="Ingrese Fecha"
                    autoComplete="off"
                    value={filter2.fechaInicio}
                    onChange={(event, newValue) => {
                        if(newValue!=undefined){
                            onChangeFecha("fechaInicio",newValue)
                        }
                    }}
                />
                <br/>
                <TextField
                    type="date"
                    label="Hasta"
                    placeholder="Ingrese Fecha"
                    autoComplete="off"
                    value={filter2.fechaFin}
                    onChange={(event, newValue) => {
                        if(newValue!=undefined){
                            onChangeFecha("fechaFin",newValue)
                        }
                    }}
                    
                /> 
                <ComboBoxComponent
                    text="Operador:"
                    selectedKey={filter2.operadorKey}
                    placeholder="Seleccione un Operador"
                    data={dataComboOperador}
                    onChange={(value) => {
                        setFilterOperador({
                            ...filterOperador,
                            search: value
                        })
                    }}
                    onOptionSelect={(event, option) => {
                        handleOnChange({
                            data: option,
                            key: 'operadorKey',
                            text: 'operadorText'
                        })
                    }}
                    defaultSelectedOptions={[{
                        key: filter2.operadorKey,
                        text: filter2.operadorText
                    }]}
                />
                <ComboBoxComponent
                    text="Estado:"
                    selectedKey={filter2.estadoKey}
                    placeholder="Seleccione un Estado"
                    data={dataComboEstadoEquipo}
                    onChange={(value) => {
                        setFilter({
                            ...filter,
                            search: value
                        })
                    }}
                    onOptionSelect={(event, option) => {
                        handleOnChange({
                            data: option,
                            key: 'estadoKey',
                            text: 'estadoText'
                        })
                    }}
                    defaultSelectedOptions={[{
                        key: filter2.estadoKey,
                        text: filter2.estadoText
                    }]}
                />
               
                {/* <pre>{JSON.stringify(filter2, null, 2)}</pre> */}
            </div>
        </Panel>
    );
};
